<template>
   <Path>
        <template v-slot:path>
            <li><router-link :to="{name: 'dashboard'}" >الصفحة الرئيسية</router-link> </li>
            <li> <span class="divider"> / </span><a href="#services" @click="$router.push({name: 'dashboard'})">الخدمات </a> </li> 
            <li> <span class="divider"> / </span><router-link :to="{name:'electronicservices'}" >الخدمات الالكترونية</router-link> </li>         
        </template>
   </Path>

  <section id="content" >
        <div class="py-6 ">
            <div class="container services_inner">

                <div id="carouselServicesInner" class="carousel slide" data-bs-ride="true">
                    <div class="carousel-inner" >
                      <div class="carousel-item active">
                        <div class="row row-cols-2 row-cols-lg-5 g-4">
                            <div class="col pointer " id ="div1">
                                <div @click="ToBirthFirstTimeRegulations"  class="scal_box rounded ">
                                    <div class="icon_holder  mt-3">
                                        <i class="bi bi-file-earmark-text"></i>
                                    </div>
                                    <p>شهادة ميلاد  اول مرة</p>
                                </div>
                            </div>
        
                            <div class="col pointer ">
                                <div @click="ToBirthRegulations" class="scal_box rounded ">
                                    <div class="icon_holder  mt-3">
                                        <!-- <button @click="ToBirthDoc" type="button" class="pa-0  ma-0  icon-btn"><i class="bi bi-file-earmark-text"></i></button> -->
                                        <i class="bi bi-file-earmark-text"></i>
                                    </div>
                                    <p>شهادة ميلاد </p>
                                </div>
                            </div>
        
                            <div class="col pointer ">
                                <div @click="ToDeathRegulations" class="scal_box rounded ">
                                    <div class="icon_holder  mt-3">
                                        <i class="bi bi-file-earmark-text"></i>
                                    </div>
                                    <p>قيد وفاة</p>
                                </div>
                            </div>
                            <div class="col pointer ">
                                <div @click="ToMarriageRegulations"  class="scal_box rounded ">
                                    <div class="icon_holder  mt-3">
                                       <i class="bi bi-file-earmark-text"></i>
                                    </div>
                                    <p>قسيمة زواج</p>
                                </div>
                            </div>
        
                            <div class="col pointer ">
                                <div  @click="ToDivorceRegulations" class="scal_box rounded ">
                                    <div class="icon_holder  mt-3">
                                       <i class="bi bi-file-earmark-text"></i>
                                    </div>
                                    <p>قسيمة طلاق</p>
                                </div>
                            </div>
        
        
                            <div class="col pointer ">
                                <div @click="ToFamilyRecordRegulations" class="scal_box rounded ">
                                    <div class="icon_holder  mt-3">
                                        <i class="bi bi-file-earmark-text"></i>
                                    </div>
                                    <p>قيد عائلي</p>
                                </div>
                            </div>
        
                            <div class="col pointer ">
                                <div @click="ToPersonalRecordRegulations" class="scal_box rounded ">
                                    <div class="icon_holder  mt-3">
                                        <i class="bi bi-file-earmark-text"></i>
                                    </div>
                                    <p>قيد فردي </p>
                                </div>
                            </div>
        
                            <div class="col pointer ">
                                <div @click="ToNidRegulations" class="scal_box rounded ">
                                    <div class="icon_holder  mt-3">
                                       <i class="bi bi-credit-card-2-front"></i>
                                    </div>
                                    <p>بطاقة رقم قومي</p>
                                </div>
                            </div>
                            <div class="col pointer ">
                                <div @click="ToNidRegulations"  class="scal_box rounded ">
                                    <div class="icon_holder  mt-3">
                                        <i class="bi bi-credit-card-2-front"></i>
                                    </div>
                                    <p>إصدار بطاقة رقم قومي لكبار السن وذوي الاحتياجات الخاصة</p>
                                </div>
                            </div>
        
                            <div class="col pointer ">
                                <div @click="ToNidFormRegulations"  class="scal_box rounded ">
                                    <div class="icon_holder  mt-3">
                                        <i class="bi bi-credit-card-2-front"></i>
                                    </div>
                                    <p>شراء استمارة رقم قومي مميكنة</p>
                                </div>
                            </div>
                        </div>
                      </div>
                       </div>
                  </div>
            </div>
        </div>
  </section>
  <router-view></router-view>
</template>

<script>
import Path from '@/components/Path.vue';

export default {
  name: 'ServicesView',
  components:{
    Path
  },
  created(){
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
  methods:{
    ToBirthRegulations(){
        this.$router.push({name:'regulations', params: {docType : 'birth'} });
    },
    ToBirthFirstTimeRegulations(){
        this.$router.push({name:'regulations', params: {docType : 'birthfirsttime'}});
    },
    ToDeathRegulations(){
        this.$router.push({name:'regulations', params: {docType : 'death'}});
    },
    ToMarriageRegulations(){
        this.$router.push({name:'regulations', params: {docType : 'marriage'}});
    },
    ToDivorceRegulations(){
        this.$router.push({name:'regulations', params: {docType : 'divorce'}});
    },
    ToNidRegulations(){
        this.$router.push({name:'regulations', params: {docType : 'nid'}});
    },
    ToNidFormRegulations(){
        this.$router.push({name:'regulations', params: {docType : 'nidform'}});
    },
    ToPersonalRecordRegulations(){
        this.$router.push({name:'regulations', params: {docType : 'personalrecord'}});
    },
    ToFamilyRecordRegulations(){
        this.$router.push({name:'regulations', params: {docType : 'familyrecord'}});
    },

  }
}
</script>
